<div
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'Item Editor Modal'"
    cdkTrapFocus
    class="item-editor-content-container"
>
    <button cdkFocusInitial class="button-undecorated button-close" (click)="closeModal()" [attr.aria-label]="'Close Item Editor modal'">
        <cwo-icon [name]="iconNameType.close" [size]="'1.25rem'" class="close-icon" />
    </button>
    <div #itemEditorScrollableWrapper class="scrollable-wrapper" id="item-editor-scrollable-wrapper">
        @if (loadingOrderableItem()) {
            @if (previewPanelItem(); as preview) {
                @if (preview.pictures[0]?.src && preview.pictures[0]?.name !== 'none') {
                    <div class="image-header-container image-header-container--preview"></div>
                }
                <div class="item-editor-preview-header">
                    <span class="preview-title">{{ preview.label }}</span>
                    @if (preview.description && configService.configState().store?.itemWebDescriptionInEditor) {
                        <span class="preview-description">{{ preview.description }}</span>
                    }
                    @if (previewPrice()) {
                        <span class="preview-price">${{ previewPrice() }}</span>
                    }
                </div>
                <div class="item-editor-choices-skeleton">
                    <div class="skeleton-choice-line"></div>
                    <div class="skeleton-choice-line skeleton-choice-line--wide"></div>
                    <div class="skeleton-choice-line"></div>
                </div>
            }
        } @else {
            @if(showImageHeader()){
            <div class="image-header-container">
                <button class="button-undecorated image-header-wrapper" (click)="openImagePreviewModal()">
                     <img [src]="picture().src" [alt]="picture().name" class="image" cwoImageFallback/>
                </button>
                @if(itemLoyaltyPoints()){
                <div *transloco="let t" class="loyalty-points-badge">
                    {{ t('modals.item_editor.loyalty_points.badge', {points: itemLoyaltyPoints()}) }}
                </div>
                }
            </div>
            }
            <cwo-item-editor-header [name]="orderableItem()?.label ?? orderableItem()?.name ?? ''" [size]="orderedItem()?.size" [orderedItem]="orderedItem()" [orderableItem]="orderableItem()" [loyaltyPoints]="showImageHeader() ? null : itemLoyaltyPoints()"></cwo-item-editor-header>

            <div #choicesWrapper class="choices-wrapper" [ngStyle]="{'padding': isEmptyBody() && !hasCalories() ? '0px': undefined, 'gap': isEmptyBody() ? '0px' : undefined}">
                
                @if (caloriesDisclaimer && hasCalories()) { <p class="calories-disclaimer">{{caloriesDisclaimer}}</p> }

                @if(orderableItem()?.choices){
                <cwo-choices [isSpecial]="false" [choices]="orderableItem()?.choices" [sizePrices]="orderableItem()?.sizePrices"
                    [orderedItem]="orderedItem()!" [toggleWarningsAfterSubmission]="toggleWarningsAfterSubmission"
                    [orderableItem]="orderableItem()!"
                    [firstInvalidChoice]="firstInvalidChoiceAfterSubmission"
                    (resetWarningsAfterSubmissionValue)="resetWarningsAfterSubmissionValue()"/>
                }

                @if(configService.configState().store?.allowCustomerInstructions || orderableItem()?.allowWebCustomerInstructions) {
                    <cwo-special-instructions-accordion
                        [title]="'Add Special Instructions'"
                        [showAlwaysExpandButton]="true"
                        [removeBorder]="true"
                        [description]="itemInstructions"
                        [maxLength]="configService.configState().store?.maxSpecialInstructionsLength" 
                        (instructionsChanged)="onInstructionsChange($event)"
                        [itemInstructionsExpanded]="configService.configState().store?.itemInstructionsExpanded ?? false"
                    />
                }
            </div>
            @if (showSisterUpsells()) {
                <cwo-upsells
                    [triggeringArea]="'Item Editor'"
                    #sisterUpsells
                    id="sister-upsells"
                    style="position: sticky; z-index: 601;"
                    [ngStyle]="{
                        'bottom': sisUpsellHeadingContentHeightDiff ? sisUpsellHeadingContentHeightDiff : null,
                        'background-color': aboveStickyLevel ? 'white' : 'transparent',
                        'visibility': sisUpsellHeadingContentHeightDiff ? 'visible' : 'hidden',
                    }"
                    [sisterUpsells]="upsellItems()"
                    [isInItemEditor]="true"
                />
            }
            <cwo-scroll-to-top [bottomOffset]="scrollToBottomOffset" [scrollContainer]="itemEditorScrollableWrapper"></cwo-scroll-to-top>
        }
    </div>
    <div #footer id="item-editor-footer" class="footer"
        [ngStyle]="{
            'box-shadow': aboveStickyLevel ? '0px 4px 10px rgba(0,0,0,0)' : '0px -4px 4px 0px rgba(0, 0, 0, 0.1)',
            'border-top' : aboveStickyLevel ? '1px solid var(--line-color)' : null
        }">
        <cwo-quantity-controls 
            [large]="true" 
            [minQuantity]="orderableItem()?.minimumQuantity ?? 1" 
            [maxQuantity]="maxQuantity"
            [inputQuantity]="orderedItem()?.quantity ?? orderableItem()?.minimumQuantity ?? 1"
            (quantityChange)="changeQuantity($event)"
            [loadingSubscription]="quantityLoadingSubscription" 
        />
        <button class="button-accent button-add" 
            cwoAsyncButton 
            [subscription]="loadingSubscription" 
            [loadingText]="markedAsEditor() ? 'Update...' : 'Add...'" 
            [ariaLabel]="'Add to order for $' + itemPrice()"
            (click)="addToOrder()"
            [itemPrice]="itemPrice()"
        >
            {{markedAsEditor() ? 'Update' : 'Add'}}
        </button>
    </div>
    
</div>
